import React, { useState, useEffect } from "react";
import { HtmlElement } from "./../../../../../helpers/HtmlElements/HtmlElements";
const TreeFormDendrometrie = ({ item, onChange }) => {
  const [formData, setFormData] = useState(item.meta || {});
  // Fonction pour gérer le changement des valeurs
  const handleChange = (id, value) => {
    const updatedData = { ...formData, [`dendrometry/${id}`]: value };
    setFormData(updatedData);
    onChange(updatedData);
  };
  // Fonction pour appliquer les calculs définis dans onBlur
  const handleBlur = (id) => {
    const field = formFields.find((f) => f.id === id);
    if (field?.onBlur) {
      const updatedMeta = { ...item.meta };
      field?.onBlur.forEach(action => {
        switch (action.action) {
          case 'calculate':
            try {

              let result = eval(action.expression.replace('item.meta', 'updatedMeta'));

              if (!isNaN(parseFloat(result))) {
                result = parseFloat(result);
              }
              updatedMeta[action.target] = result;
            } catch (e) {

              updatedMeta[action.target] = ''
            }
            break;
        }
      });
      onChange({ meta: updatedMeta });
    }
  };
  // Définition des champs
  const formFields = [
    {
      id: "circumference",
      type: "input",
      igAfter: "CM",
      active: true,
      text: "Circonférence",
      unity: "M.",
      onBlur: [
        { action: "calculate", target: "dendrometry/diameter", expression: "(item.meta['dendrometry/circumference'] / Math.PI).toFixed(1);" },
        { action: "calculate", target: "dendrometry/rpz", expression: "(24 * (item.meta['dendrometry/circumference']/100) / Math.PI).toFixed(1);" },
        { action: "calculate", target: "dendrometry/estimatedAge", expression: "((item.meta['dendrometry/circumference'])/2.5).toFixed(0);" },
        {
          action: "calculate",
          target: "dendrometry/hdValue",
          expression: "(item.meta['dendrometry/diameter'] && item.meta['dendrometry/height']) ? (item.meta['dendrometry/height']/(item.meta['dendrometry/diameter']*100)).toFixed(3) : '';"
        }
      ]
    },
    { id: "estimatedAge", type: "number", active: true, text: "Âge estimé" },
    {
      id: "diameter",
      type: "input",
      igAfter: "CM",
      active: true,
      text: "Diamètre",
      onBlur: [
        {
          action: "calculate",
          target: "dendrometry/hdValue",
          expression: "(item.meta['dendrometry/height']) ? (item.meta['dendrometry/height']/(item.meta['dendrometry/diameter']*100)).toFixed(3) : '';"
        }
      ]
    },
    { id: "rpz", type: "input", active: true, igAfter: "M", text: "Zone de protection racinaire" },
    {
      id: "height",
      igAfter: "M",
      type: "input",
      active: true,
      text: "Hauteur",
      onBlur: [
        {
          action: "calculate",
          target: "dendrometry/hdValue",
          expression: "(item.meta['dendrometry/diameter']) ? (item.meta['dendrometry/height']/(item.meta['dendrometry/diameter']*100)).toFixed(3) : '';"
        }
      ]
    },
    { id: "hdValue", type: "input", active: true, text: "Valeur Hauteur / Diamètre" },
    { id: "numberOfTrunks", type: "input", active: true, text: "Nombre de troncs" },
    { id: "crownSpan", igAfter: "M", type: "input", active: true, text: "Envergure du houppier" },
    { id: "heightOfFirstBranch", type: "input", active: true, text: "Hauteur 1ère branche", igAfter: "M", },
    { id: "inclination", type: "input", active: false, text: "Inclinaison" },
  ];
  return (
    <div className="card card-identity">
      <h6 className='card-title mb-3'>Dendométrie</h6>
      <div className="card-body pt-0">
        <div className="row">
          {formFields.map(({ id, type, text, igAfter, active }) =>
            active ? (
              <div key={id} className="col-12 col-sm-6  col-md-4 col-lg-3 mb-3">
                <label className="form-group-label mb-1">{text} :</label>
                <div className="input-group input-group-sm">
                  <HtmlElement.input
                    type={type}
                    name={`meta.dendrometry/${id}`}
                    value={item.meta[`dendrometry/${id}`] || ""}
                    onChange={onChange}
                    onBlur={() => handleBlur(id)}
                    className="form-control form-control-sm"
                  />
                  {igAfter && <span className="input-group-text" >{igAfter}</span>}
                </div>
              </div>
            ) : null
          )}
        </div>
      </div>
    </div>
  );
};
export default TreeFormDendrometrie;
